import { render } from "./ViewVision.vue?vue&type=template&id=2486a23d"
import script from "./ViewVision.vue?vue&type=script&lang=js"
export * from "./ViewVision.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__